export enum ElementType {
	TextElement = "TextElement",
	ImageElement = "ImageElement",
	SelectQuestion = "SelectQuestion",
	TextQuestion = "TextQuestion",
	ImageQuestion = "ImageQuestion",
	FileQuestion = "FileQuestion",
	DateTimeQuestion = "DateTimeQuestion",
	NumberQuestion = "NumberQuestion",
	SliderQuestion = "SliderQuestion",
	EmailQuestion = "EmailQuestion",
	ScannerQuestion = "ScannerQuestion",
	DurationQuestion = "DurationQuestion",
	SignatureQuestion = "SignatureQuestion",
	UnknownQuestion = "UnknownQuestion",
	SelectQuestionGroup = "SelectQuestionGroup",
}
